import React, { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
export const CTAButton = ({
  children,
  className = '',
  onClick,
  href = 'https://origenlabonline.shop/cart/47002608337047:1'
}: any) => <a href={href} onClick={onClick} className={`inline-flex items-center justify-center bg-cta hover:bg-cta-hover text-white font-bold py-4 px-8 rounded-full shadow-[0_4px_14px_rgba(61,155,110,0.4)] transition-all duration-300 transform hover:scale-105 w-full md:w-auto text-center uppercase tracking-wide text-sm md:text-base ${className}`} data-id="element-185">
    {children}
    <ChevronRight className="ml-2 w-5 h-5" data-id="element-186" />
  </a>;
export const FadeIn = ({
  children
}: {
  children: React.ReactNode;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.6
}} data-id="element-187">
    {children}
  </motion.div>;
export const Section = ({
  children,
  className = '',
  id
}: any) => <section id={id} className={`py-16 md:py-24 px-6 md:px-12 max-w-6xl mx-auto ${className}`} data-id="element-188">
    {children}
  </section>;
export const SectionTitle = ({
  children,
  className = ''
}: any) => <h2 className={`font-playfair text-3xl md:text-5xl text-charcoal mb-6 text-center leading-tight ${className}`} data-id="element-189">
    {children}
  </h2>;
export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex flex-col items-center mt-6 mb-8" data-id="element-190">
      <p className="text-sm font-bold text-charcoal uppercase tracking-wider mb-1" data-id="element-191">
        ⚠️ Hoy estás viendo esta página con 50% OFF activo
      </p>
      <p className="text-xs text-charcoal-light uppercase tracking-wider mb-3" data-id="element-192">
        Oferta disponible por tiempo limitado
      </p>
      <div className="flex gap-4 text-center" data-id="element-193">
        <div className="bg-white border border-beige-muted rounded-lg w-16 h-16 flex flex-col items-center justify-center shadow-sm" data-id="element-194">
          <span className="text-2xl font-playfair font-bold text-sage-dark" data-id="element-195">
            {String(timeLeft.hours).padStart(2, '0')}
          </span>
          <span className="text-[10px] uppercase text-charcoal-light" data-id="element-196">
            Horas
          </span>
        </div>
        <div className="text-2xl font-playfair font-bold text-sage-dark self-center -mt-4" data-id="element-197">
          :
        </div>
        <div className="bg-white border border-beige-muted rounded-lg w-16 h-16 flex flex-col items-center justify-center shadow-sm" data-id="element-198">
          <span className="text-2xl font-playfair font-bold text-sage-dark" data-id="element-199">
            {String(timeLeft.minutes).padStart(2, '0')}
          </span>
          <span className="text-[10px] uppercase text-charcoal-light" data-id="element-200">Min</span>
        </div>
        <div className="text-2xl font-playfair font-bold text-sage-dark self-center -mt-4" data-id="element-201">
          :
        </div>
        <div className="bg-white border border-beige-muted rounded-lg w-16 h-16 flex flex-col items-center justify-center shadow-sm" data-id="element-202">
          <span className="text-2xl font-playfair font-bold text-sage-dark" data-id="element-203">
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
          <span className="text-[10px] uppercase text-charcoal-light" data-id="element-204">Seg</span>
        </div>
      </div>
    </div>;
};